<template>
  <b-modal ref="station-modal" :title="getTitle()" hide-footer>
    <div v-if="displayPopover()" class="card-overlay">
      <div class="card-text">
        <p>Poste <b>en rouge</b> si elle contient plus de documents que le <b> nombre maximum de documents</b> défini</p>
        <p>Document <b>en rouge</b> si le Lead Time de ce document dépasse l'<b>objectif lead time </b></p>
      </div>
      <br>
      <b-form-checkbox
        id="checkbox-popover"
        v-model="popoverDontShowAgain"
        name="checkbox-popover"
        value="understood"
        unchecked-value="not_understood"
      >
        Ne plus montrer ce message
      </b-form-checkbox>
      <div style="text-align: right; margin-top: 5%">
        <b-button
          style=""
          variant="primary"
          @click="changeLocalStorageValue()"
        >
          Valider
        </b-button>
      </div>
    </div>
    <div :class="{'blur-background': displayPopover() }">
      <h3 id="title-popover-sync" >{{title}}</h3>
      <div class="d-block text-center">
        <b-container fluid>
          <b-form @submit.stop.prevent="onSubmit" v-if="!updateSucceed && !updateFailed">
            <b-form-group
              id="maxKanban"
              label="Nombre maximum de documents"
              label-for="maxKanbanInput"
            >
              <b-form-input
                id="maxKanbanInput"
                type="number"
                min="0"
                v-model="newNbKanbanMax"
                required
                oninput="validity.valid||(value='');"
              />
            </b-form-group>
            <b-form-group
              id="targetLeadTime"
              label="Objectif Lead Time (en heure)"
              label-for="targetLeadTimeInput"
            >
              <b-form-input
                id="targetLeadTimeInput"
                type="number"
                min="0"
                v-model="newLeadTimeTarget"
                oninput="validity.valid||(value='');"
                required
              />
            </b-form-group>
            <div>
              <b-button
                variant="outline-danger"
                @click="hideModal()"
                class="mr-2"
                >Annuler</b-button
              >
              <b-button
                type="submit"
                variant="primary"
                :disabled="!newNbKanbanMax && !newLeadTimeTarget">
                Valider
              </b-button>
            </div>
          </b-form>
          <div v-if="updateSucceed">
            <div class="icon-result">
              <span style="color: #b0d876; font-size: 4rem;"><i class="fa fa-check-circle"></i></span>
            </div>
            <div class="text-result"> Document maximum <span>{{newNbKanbanMax}}</span></div>
            <div class="text-result"> Lead time maximum <span>{{newLeadTimeTarget}}</span> </div>
            <b-button
              style="margin-top: 5%; padding-left: 5%; padding-right: 5%;"
              @click="updateSuccess()"
              variant="primary"
            >
              Ok
            </b-button>
          </div>
          <div v-if="updateFailed">
            <div class="icon-result">
              <span style="color: #ff4b4b; font-size: 4rem;"><i class="fa fa-times-circle"></i></span>
            </div>
            <div class="text-result">{{errorMessage}}</div>
             <b-button
              style="margin-top: 5%; padding-left: 5%; padding-right: 5%;"
              @click="hideModal()"
              variant="primary"
            >
              Ok
            </b-button>
          </div>
        </b-container>
      </div>
    </div>
  </b-modal>
</template>
<script>
import server from '../api/server.vue'
import _ from 'lodash'

export default {
  name: 'station-modal',
  props: ['title', 'stationsList'],
  data() {
    return {
      updateAllStations: false,
      newLeadTimeTarget: 0,
      newNbKanbanMax: 0,
      oldLeadTimeTarget: 0,
      oldNbKanbanMax: 0,
      station: {},
      showPopover: true,
      popoverDontShowAgain: 'not_understood',
      errorMessage: '',
      updateSucceed: false,
      updateFailed: false,
      clickDisplay: false
    }
  },
  methods: {
    getTitle () {
      return this.showPopover ? 'Information concernant les andons' : 'Définir le seuil d\'andon'
    },
    updateWorkstationAndon() {
      let params = { nb_documents: parseInt(this.newNbKanbanMax, 10) }
      server
        .addWorkstationAndon(this.station.loop, this.station.name, params)
        .catch(() => {
          this.errorMessage = `Une erreure s'est produite lors de la mise à jour des andons`
        })
    },
    updateScanDocumentAndons() {
      let maxLeadTime = parseInt(this.newLeadTimeTarget, 10)
      this.station.kanbanCards.forEach(kanban => {
        if (parseInt(kanban.leadTime, 10) >= maxLeadTime) {
          server
            .addScanDocumentAndon(kanban.code)
            .catch(() => {
              this.errorMessage = `Une erreure s'est produite lors de la mise à jour des andons`
            })
        } else if (!_.isEmpty(kanban.andonData)) {
          server
            .stopSpecificAndon(kanban.andonData.base_id)
            .catch(() => {
              this.errorMessage = `Une erreure s'est produite lors de la mise à jour des andons`
            })
        }
      })
    },
    updateWorkstation() {
      let params = {
        name: this.station.name,
        workstation_to_update: this.station.name,
        max_lead_time: parseInt(this.newLeadTimeTarget, 10),
        max_documents: parseInt(this.newNbKanbanMax, 10),
        position: this.station.position
      }
      server
        .updateWorkstation(this.station.loop, params)
        .catch((err) => {
          this.errorMessage = `Une erreure s'est produite lors de la mise à jour de la workstation`
        })
    },
    updateSuccess () {
      this.updateSucceed = false
      this.updateFailed = false
      this.hideModal()
    },
    updateProps (station) {
      this.station = station
      this.oldLeadTimeTarget = this.station.leadTimeTarget
      this.oldNbKanbanMax = this.station.nbKanbanMax

      this.newLeadTimeTarget = this.station.leadTimeTarget
      this.newNbKanbanMax = this.station.nbKanbanMax
    },
    onSubmit (evt) {
      const promises = []
      promises.push(this.updateWorkstation())
      promises.push(this.updateScanDocumentAndons())
      if (this.station.nbKanbanMax < this.station.kanbanCards.length) {
        promises.push(this.updateWorkstationAndon())
      }
      Promise.all(promises).then(() => {
        this.$emit('station-modal-closed')
        this.setProtectedTimeout(() => {
          if (this.errorMessage !== '') {
            this.updatedFailed = true
          } else {
            this.updateSucceed = true
          }
        }, 800)
      }).catch((error) => {
        this.updatedFailed = true
      })
    },
    hideModal () {
      this.$refs['station-modal'].hide()
    },
    showModal () {
      this.$refs['station-modal'].show()
    },
    changeLocalStorageValue () {
      window.localStorage.setItem('InfoPopoverShow', this.popoverDontShowAgain)
      this.showPopover = false
      this.clickDisplay = true
    },
    displayPopover () {
      if (window.localStorage.getItem('InfoPopoverShow')) {
        const popoverDontShowAgain = window.localStorage.getItem('InfoPopoverShow')
        if (!this.clickDisplay) {
          this.showPopover = popoverDontShowAgain === 'understood' ? false : true
        }
      }
      return this.showPopover
    }
  },
  watch: {}
}
</script>

<style lang="scss">
  .icon-result {
    justify-content: center;
    align-items: center;
    position: relative;
    display: flex;
    padding: 1.5rem;
    width: 100%;
  }

  .text-result {
    font-size: 1.2rem;
    font-weight: normal;
    // margin-bottom: 3%;
  }

  .text-result span {
    // text-transform: uppercase;
    font-weight: bold;
  }

  .card-overlay {
    position: absolute;
    background-color: rgba(204,204,204,0.5);
    z-index: 2;
    backdrop-filter: blur(15px);
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0.5rem 1.25rem;
  }

  .card-overlay .card-text {
    margin-top: 3%;
  }

  @-moz-document url-prefix() {
    .blur-background {
      filter: blur(20px);
    }

    .card-overlay{
      background-color: #ffffff59;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/StationModal.vue